export const environment = {
  production: false,
  environmentLabel: '',
  server: 'https://jul.nsw.pt/',
  julWebServer: 'https://jul.nsw.pt/jul-web/',
  gadUrl: 'https://jul.nsw.pt/gad-services/api',
  serverUrl: 'https://jul.nsw.pt/gad-services/api',
  serverUrlNotifier: 'https://jul.nsw.pt/notifier-services/api',
  logoutUrl: 'https://jul.nsw.pt',
  loginUrl: 'https://jul.nsw.pt',
  coreServer: 'https://jul.nsw.pt/jul-web', 
  serverUrlRTM: 'https://jul.nsw.pt/rtm-services/api',
  serverUrlSummary: 'https://jul.nsw.pt/summary-services/api',
  serverUrlMD: 'https://jul.nsw.pt/md-services/api',
};
